import { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer'
import MuiDrawer from '@mui/material/Drawer'

const Drawer = (props: MuiDrawerProps): JSX.Element => {
    return (
        <MuiDrawer
            variant="temporary"
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
                'display': { xs: 'block', md: 'none' },
                '& .MuiDrawer-paper': {
                    boxSizing: 'border-box',
                    backgroundImage: 'none',
                    width: '60%',
                    minWidth: 300,
                    height: '100%',
                },
            }}
            {...props}>
            {props.children}
        </MuiDrawer>
    )
}

export default Drawer
